export default __webpack_public_path__ + "static/media/cotton.162d95ea.png";